import { useState, useCallback } from "react";
const useYearMonthSelector = (type, onChange) => {
  const [monthYearSelectorShown, showMonthYearSelector] = useState(!1), [currentSelectorType, setCurrentSelectorType] = useState("year"), close = () => {
    showMonthYearSelector(!1);
  }, toggleShown = useCallback(() => {
    showMonthYearSelector((prev) => !prev);
  }, []), handleChange = useCallback(
    (date) => {
      currentSelectorType === "month" ? (showMonthYearSelector(!1), setCurrentSelectorType("year")) : setCurrentSelectorType("month"), onChange(date, type);
    },
    [currentSelectorType, onChange, type]
  ), toggleMonthYear = useCallback(
    (toggleType) => {
      toggleType && (toggleType === currentSelectorType || !monthYearSelectorShown) && showMonthYearSelector((prev) => !prev), setCurrentSelectorType(
        (d) => toggleType ?? (d === "year" ? "month" : "year")
      );
    },
    [currentSelectorType, monthYearSelectorShown]
  );
  return {
    shown: monthYearSelectorShown,
    type: currentSelectorType,
    handleChange,
    toggleShown,
    toggleMonthYear,
    close
  };
};
export {
  useYearMonthSelector
};
//# sourceMappingURL=useYearMonthSelector.js.map
